import { motion } from 'framer-motion';
import { ReactNode } from 'react';

export default function AmbientLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-screen overflow-x-hidden">
      {/* Floating blobs */}
      <div className="pointer-events-none fixed inset-0 z-0">
        <div
          className="blob animate-float-1"
          style={{
            width: 360, height: 360, top: '-80px', left: '-80px',
            background: 'hsl(var(--domain-motor))', opacity: 0.5,
          }}
        />
        <div
          className="blob animate-float-2"
          style={{
            width: 420, height: 420, top: '40%', right: '-120px',
            background: 'hsl(var(--domain-language))', opacity: 0.45,
          }}
        />
        <div
          className="blob animate-float-3"
          style={{
            width: 380, height: 380, bottom: '-100px', left: '20%',
            background: 'hsl(var(--domain-cognitive))', opacity: 0.5,
          }}
        />
      </div>
      <div className="grain" />
      <motion.main
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        className="relative z-10 mx-auto w-full max-w-md px-5 pt-6 pb-28"
      >
        {children}
      </motion.main>
    </div>
  );
}
